module.exports = __webpack_public_path__ + "img/gaojing.5aeeaa8c.png";